import type { CubeProducer } from "../../../hooks/useForecastWorkspace";

/** How the menu and the toast name the cube a copy lands in. */
export interface CopyTarget {
  /** The cube, in the menu label: "Copy row to user cube". */
  cube: string;
  /** A ticked target row, in the toast's *Not copied* list. */
  ownRow: string;
  /** A source row whose KPI and fiscal year the target cube lacks. */
  notInTarget: string;
}

/**
 * A budget is shared, so its rows are not the planner's "own" and the cube is
 * not "your version" (SPEC.md § On the budget page).
 */
export const COPY_TARGET: Record<CubeProducer, CopyTarget> = {
  user: {
    cube: "user cube",
    ownRow: "own row",
    notInTarget: "not in your version"
  },
  budget: {
    cube: "budget cube",
    ownRow: "budget row",
    notInTarget: "not in this budget"
  }
};
